import { useContext } from 'react';
import { ThemeContext } from '@/contexts/ThemeContext';
import { invariant } from '@/utils/invariant';

export function useTheme() {
  return invariant(useContext(ThemeContext), 'useTheme must be used inside <ThemeProvider>.');
}
